import { AppBar, Box, Drawer, Fab, IconButton, styled, Toolbar, useMediaQuery } from '@mui/material'
import { inject, observer } from 'mobx-react'
import React from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import { ReactNode } from 'react'
import { theme } from 'config'
import { RoutingStore } from '../stores'
import { Logo } from 'assets/svg/logo';
import { routingStore } from 'app';
import { Icon } from './icon';

export interface IPageContainerProps {
  children?:     ReactNode,
  routingStore?: RoutingStore,
}

export const PageContainer = inject('routingStore')(observer((props: IPageContainerProps): JSX.Element => {
  const sidebarContainerRef = React.useRef<HTMLElement>();
  const topbarContainerRef  = React.useRef<HTMLElement>();
  const isNotMobileView     = useMediaQuery(theme.breakpoints.up('sm'));
  const { sidebarDrawerOpen } = props.routingStore;

  React.useEffect(() => {
    props.routingStore.setSidebarContainer(sidebarContainerRef.current)
  }, [sidebarContainerRef, isNotMobileView]);

  React.useEffect(() => {
    props.routingStore.setTopbarContainer(topbarContainerRef.current)
  }, [topbarContainerRef, isNotMobileView]);

  React.useEffect(() => {
    if(isNotMobileView) routingStore.openSidebarDrawer(true);
    else routingStore.openSidebarDrawer(false);
  }, [isNotMobileView]);

  return (
    <Box display='flex'>
      <AppBar
        position='fixed'
        className='HEADER'
        sx={{
          height: isNotMobileView ? `${theme.topbarHeight}` : '40px', // Set height for mobile or default for larger screens
          width: { xs: '100%' },
          ml: `${theme.drawerWidth}`,
          pt: '1rem',
        }}
      >
        <Toolbar
        
        className='TOOLBAR'
          sx={{
            paddingLeft: { xs: '3rem' },
            justifyContent: { xs: 'flex-end' },
            minHeight: 0,
          }}
        >
          {isNotMobileView ? (
            <Box width='100%' ref={topbarContainerRef} id='topbar_container' />
          ) : (
            <IconButton
              color='inherit'
              aria-label='open drawer'
              onClick={() =>
                props.routingStore.openSidebarDrawer(!sidebarDrawerOpen)
              }
              edge='start'
            >
              <MenuIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          display: { xs: !sidebarDrawerOpen && 'none', sm: 'block' },
          width: theme.drawerWidth,
          flexShrink: 0,
        }}
        anchor='left'
        variant='persistent'
        open={isNotMobileView || sidebarDrawerOpen}
      >
        <Box
          pt={4}
          display='flex'
          color='white'
          justifyContent={isNotMobileView ? 'center' : 'space-between'}
          padding={isNotMobileView ? 0 : '1.6rem'}
          alignItems='center'
          marginTop={isNotMobileView ? '2.4rem' : '1.6rem'}
        >
          <Logo color='white' width={!isNotMobileView ? 100 : 148} />
          {!isNotMobileView && (
            <CloseIcon
              size='size-18'
              iconId='remove'
              onClick={() =>
                props.routingStore.openSidebarDrawer(!sidebarDrawerOpen)
              }
            />
          )}
        </Box>
        <Box ref={sidebarContainerRef} id='sidebar_container'></Box>
      </Drawer>
      {props.children}
    </Box>
  )
}));

const CloseIcon = styled(Icon)`
  svg {
    color: white;
  }
`;